"use client";

import React from "react";
import { cn } from "utils";

export const PlaidImportLoadingSkeleton: React.FC = () => (
  <div
    className="flex h-full w-full flex-col bg-background_solid_neutral_secondary px-4 pt-2"
    data-testid="plaid-import-loading-skeleton"
  >
    <div className="mb-6 size-10 animate-pulse rounded-full bg-background_white_overlay10" />
    <div className="mb-6 h-8 w-48 animate-pulse rounded bg-background_white_overlay10" />
    <div className="flex flex-col gap-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className={cn(
            "flex items-center gap-3 rounded-lg bg-background_solid_neutral_primary p-3",
          )}
        >
          <div className="size-8 animate-pulse rounded-full bg-background_white_overlay10" />
          <div className="flex flex-1 flex-col gap-2">
            <div className="h-4 w-32 animate-pulse rounded bg-background_white_overlay10" />
            <div className="h-3 w-24 animate-pulse rounded bg-background_white_overlay10" />
          </div>
          <div className="size-9 animate-pulse rounded-full bg-background_white_overlay10" />
        </div>
      ))}
    </div>
  </div>
);
